import React from 'react';
import {Row, Col, Card} from 'react-materialize';


import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"workplace_protection_title"} defaultMessage={"Como empregadores podem melhorar a segurança do local de trabalho?"}/></b></p></h5>
            </div>
            <div align="justify" style={{padding:"50px"}}>
                <ul>
                    <li>• <FormattedMessage id={"workplace_protection_text_1"} defaultMessage={"Verifique se os locais de trabalho estão limpos e higienizados."}/></li>
                    <li>• <FormattedMessage id={"workplace_protection_text_2"} defaultMessage={"As superfícies precisam ser limpas com desinfetante regularmente, porque a contaminação nas superfícies tocadas por funcionários e clientes é uma das maneiras pelas quais o coronavírus se espalha."}/></li>
                    <li>• <FormattedMessage id={"workplace_protection_text_3"} defaultMessage={"Coloque dispensadores de desinfetante para as mãos (álcool gel) em locais de destaque no local de trabalho."}/></li>
                    <li>• <FormattedMessage id={"workplace_protection_text_4"} defaultMessage={"Exibir pôsteres promovendo a lavagem das mãos."}/></li>
                    <li>• <FormattedMessage id={"workplace_protection_text_5"} defaultMessage={"Certifique-se de que as pessoas tenham acesso a lugares onde possam lavar as mãos com água e sabão."}/></li>
                    <li>• <FormattedMessage id={"workplace_protection_text_6"} defaultMessage={"Instale um banho de pés (lava-pés) na entrada de fazendas e locais fechados, como laboratórios, locais onde são realizados cuidados, criação, desova, etc."}/></li>
                    <li>• <FormattedMessage id={"workplace_protection_text_7"} defaultMessage={"Certifique-se de que os trabalhadores mantenham 2 metros de distância entre si."}/></li>
                    <li>• <FormattedMessage id={"workplace_protection_text_8"} defaultMessage={"Produtores, trabalhadores e colaboradores do grupo de risco (acima de 60 anos, pessoas com problemas médicos, como doenças cardiovasculares, diabetes, doenças respiratórias crônicas e câncer), devem permanecer em casa."}/></li>
                </ul>
            </div>
            <div align="center">
                <a href={"/protection"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>

        

    </Card>

);

export default Sobre;